import type { EmbedStoryParams } from 'src/sdk/types';
import { DEFAULT_PARAMS } from 'src/sdk/constants';

type SettingsReducer = {
	cardHeight: number;
	embed: EmbedStoryParams;
	isEventBridgeLoading: boolean;
};

const initialState: SettingsReducer = {
	cardHeight: 0,
	embed: { ...DEFAULT_PARAMS },
	isEventBridgeLoading: false,
};

export default initialState;
